import { useAuth } from '@/hooks/useAuth';
import DashboardPage from './dashboard';
import MerchantDashboard from './MerchantDashboard';
import DelegateDashboard from './DelegateDashboard';

export default function SmartDashboard() {
  const { user } = useAuth();
  const role = user?.role || 'staff';

  if (role === 'merchant') {
    return <MerchantDashboard />;
  }
  
  if (role === 'delegate') {
    return <DelegateDashboard />;
  }
  
  // admin أو staff
  return <DashboardPage />;
}
